import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle({ target }) {
    const text = target.checked
      ? 'Lock all and request signatures'
      : 'Yes, Lock all'
    const frame = this.element.closest('turbo-frame')
    const button = frame?.querySelector('[data-reporting-cycles--confirm-bulk-lock-target="submitButton"]')
    if (!button) return

    button.value = text
    const content = button.querySelector('.button__content')
    if (content) content.textContent = text
  }
}
